var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.to ? 'a' : 'div', {
    tag: "component",
    style: {
      'aspect-ratio': _vm.aspectRatio
    },
    attrs: {
      "href": _vm.to ? _vm.$router.resolve(_vm.to).href : null,
      "title": _vm.title
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.to ? _vm.$router.push(_vm.to) : null;
      }
    }
  }, [_c(_vm.eager ? 'div' : _vm.VLazy, {
    tag: "component"
  }, [_vm.isVideo ? [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "aria-label": _vm.alt,
      "poster": `${_vm.BASE_URL}/${_vm.id}/lg.webp`
    },
    domProps: {
      "muted": true
    },
    on: {
      "loadeddata": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  }, [_vm._l(_vm.SIZES, function (_ref, i) {
    var key = _ref[0],
      w = _ref[1];
    return _c('source', {
      attrs: {
        "type": "video/mp4",
        "src": `${_vm.BASE_URL}/${_vm.id}/${key}.mp4`,
        "media": i == 2 ? null : `(max-width: ${w}px)`
      }
    });
  }), _c('img', {
    attrs: {
      "type": "image/webp",
      "srcset": _vm.SIZES.map(function (_ref2) {
        var key = _ref2[0],
          w = _ref2[1];
        return `${_vm.BASE_URL}/${_vm.id}/${key}.webp ${w}w`;
      }).join(', '),
      "src": `${_vm.BASE_URL}/${_vm.id}/lg.webp`,
      "alt": _vm.alt
    },
    on: {
      "load": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  })], 2)] : _c('img', {
    attrs: {
      "type": "image/webp",
      "srcset": _vm.SIZES.map(function (_ref3) {
        var key = _ref3[0],
          w = _ref3[1];
        return `${_vm.BASE_URL}/${_vm.id}/${key}.webp ${w}w`;
      }).join(', '),
      "src": `${_vm.BASE_URL}/${_vm.id}/lg.webp`,
      "alt": _vm.alt
    },
    on: {
      "load": function ($event) {
        return _vm.$emit('loaded');
      }
    }
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }